import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { setCookie } from "../../helpers/cookie";
import type { CommonVariables } from "../../../types/globalTypes";

// Define the shape of our Currency state
export interface CurrencyState {
  currentCurrency: string;
  supportedCurrencies: string[];
  symbols: Record<string, string>;
}

// Extract the injected data from PHP (ScriptLocalizationService)
const currencyData = (window.commonVariables as CommonVariables | undefined)
  ?.currencyInfo || {
  current: "TRY",
  supported: ["TRY"],
  symbols: { TRY: "₺" },
};

const initialState: CurrencyState = {
  currentCurrency: currencyData.current,
  supportedCurrencies: currencyData.supported,
  symbols: currencyData.symbols,
};

export const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setCurrency: (state, action: PayloadAction<string>) => {
      // Only update if it's a supported currency
      if (state.supportedCurrencies.includes(action.payload)) {
        state.currentCurrency = action.payload;

        // Synchronize with Aelia Currency Switcher via Cookie
        // This ensures the next PHP render or standard API call uses the new currency
        setCookie("aelia_cs_currency", action.payload, 365);
      }
    },
  },
});

export const { setCurrency } = currencySlice.actions;

export default currencySlice.reducer;
